module.exports = __webpack_public_path__ + "img/balkon04.cda0c9da.jpg";